// This logic allows seamless switching between local dev and production
const API_BASE_URL =
  process.env.REACT_APP_TRANSCRIPTION_BACKEND_URL ||
  process.env.REACT_APP_BACKEND_URL ||   
  process.env.NEXT_PUBLIC_BACKEND_URL ||  
  "http://localhost:8001";               

console.log("API URL set to:", API_BASE_URL); // Debug log

export default API_BASE_URL;

export const FRONTEND_URL =
  process.env.REACT_APP_FRONTEND_URL ||
  process.env.NEXT_PUBLIC_FRONTEND_URL ||
  "http://localhost:3000"; // fallback for local dev

/**
 * Vercel hosts `/api/*` on the same origin. Use empty base.
 * For local dev, run `vercel dev` (recommended) or set REACT_APP_BILLING_API_BASE
 * to the origin that serves the API.
 */
export function getBillingApiBase() {
  return (process.env.REACT_APP_BILLING_API_BASE || "").trim().replace(/\/$/, "");
}

/**
 * @param {string} path e.g. "/api/create-checkout-session"
 */
export function billingApiPath(path) {
  const p = path.startsWith("/") ? path : `/${path}`;
  const b = getBillingApiBase();
  return b ? `${b}${p}` : p;
}

/** sessionStorage key for Stripe return URL `session_id` (guest link-after-sign-in) */
export const STRIPE_CHECKOUT_SESSION_STORAGE_KEY = "stripe_pending_checkout_session";
